export const layout = {
  container: {
    px: 20,
  },
  inputDefault: {
    borderRadius: 5,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '$primary',
  },
  inputDefaultFocus: {
    borderRadius: 5,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '$primary',
  },
  inputError: {
    borderRadius: 5,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '$danger',
  },
  inputDisabled: {
    disabled: true,
    borderRadius: 5,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '$disable',
    backgroundColor: '$disable',
  },
  row: {
    flexDirection: 'row',
  },
  col: {
    flexDirection: 'column',
  }
};